import { Modal } from '@mui/material';
import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

export interface CancelRouteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  routeName?: string | null;
  ordersCount?: number;
}

const CancelRouteModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting,
  routeName,
  ordersCount,
}: CancelRouteModalProps) => (
  <Modal open={open} onClose={onClose}>
    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md'>
      <div className='flex flex-col p-6 gap-4 bg-white outline-none rounded-lg shadow-xl'>
        <h2 className='text-lg font-semibold text-gray-800'>Cancelar ruta</h2>

        <div className='flex flex-col gap-2 text-sm text-gray-700'>
          <p>
            Vas a cancelar la ruta{' '}
            <span className='font-semibold'>
              {routeName?.trim() || 'sin nombre'}
            </span>
            .
          </p>
          <ul className='list-disc pl-5 space-y-1'>
            <li>
              {typeof ordersCount === 'number' && ordersCount > 0
                ? `Sus ${ordersCount} pedido(s) vuelven a Pendiente`
                : 'Sus pedidos vuelven a Pendiente'}{' '}
              y queda registrado en el historial de cada uno. La liberación se
              procesa por cola, así que puede tardar unos segundos en verse.
            </li>
            <li>Las visitas abiertas quedan canceladas.</li>
            <li>El conductor queda desasignado.</li>
          </ul>
          <p className='text-red-600 font-medium'>
            Esta acción no se puede deshacer. La ruta queda solo informativa.
          </p>
        </div>

        <div className='flex gap-3 justify-end pt-2'>
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={onClose}
            disabled={isSubmitting}
          >
            Volver
          </GlobalButton>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Cancelando…' : 'Cancelar ruta'}
          </GlobalButton>
        </div>
      </div>
    </div>
  </Modal>
);

export default CancelRouteModal;
